import config from '../config';
import http from '../utils/http';
import { IApplicationState } from '../reducers';
import actionTypes from '../actions/actionTypes';
import { Dispatch } from 'redux';
import { getAvailableProjects } from '@nexxt/common/firebase/auth/userDetails';
import { PROJECT_BASE_COST } from '../constants/project';

const { api } = config;

export async function getPaymentIntent(data) {
    try {
        const url = api.endpoints.payment;

        const response = await http.post(url, data);

        return response;
    } catch (err) {
        throw err;
    }
}

export function getPrice(data) {
    const url = `${api.endpoints.payment}/price`;
    const availableProjects = getAvailableProjects();
    const basePrice = availableProjects ? 0 : PROJECT_BASE_COST;
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        try {
            const response = await http.get(url, {
                params: { ...data, basePrice }
            });
            dispatch({
                type: actionTypes.GET_PRICE,
                payload: response.data
            });
            return response;
        } catch (e) {
            throw e;
        }
    };
}
